export const ActiveAgreement = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} {...props}>
    <path
      d="M9.531 4A2.633 2.633 0 0 0 7 6.7v18.6A2.633 2.633 0 0 0 9.531 28h12.938A2.633 2.633 0 0 0 25 25.3V12.7a.931.931 0 0 0-.247-.636l-.009-.009-7.3-7.791a.818.818 0 0 0-.6-.264Zm8.156 3.073 4.432 4.727h-3.588a.86.86 0 0 1-.844-.9ZM16 16a.7.7 0 0 1 .456.169l2.637 2.216a.8.8 0 0 1 .28.618v3.353a.206.206 0 0 1-.211.225h-6.327a.206.206 0 0 1-.211-.225V19a.806.806 0 0 1 .281-.619l2.636-2.216A.7.7 0 0 1 16 16Zm-.562 3a.582.582 0 0 0-.563.6v1.2a.582.582 0 0 0 .563.6h1.125a.582.582 0 0 0 .563-.6v-1.2a.582.582 0 0 0-.563-.6Z"
      fill="#50cbc7"
      data-name="Group 96941"
    />
  </svg>
)
